import { MaintenanceActions } from './action-creators';
import { Reducer } from 'redux';
import { actionTypes } from './action-types';

export interface MaintenanceStore {
  maintenanceFlg: boolean;
}

const initialState: MaintenanceStore = {
  maintenanceFlg: false,
};

export const maintenanceReducer: Reducer<
  MaintenanceStore,
  MaintenanceActions
> = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_MAINTENANCE_FLAGS:
      return {
        ...state,
        maintenanceFlg: action.payload,
      };
    // ログアウト要求系フラグクリア
    case actionTypes.CLEAR_MAINTENANCE_FLAGS:
      return {
        ...state,
        maintenanceFlg: false,
      };
    default:
      return state;
  }
};
